import { render, staticRenderFns } from "./AdminTab_Duck.vue?vue&type=template&id=a4343c04&scoped=true"
import script from "./AdminTab_Duck.vue?vue&type=script&lang=js"
export * from "./AdminTab_Duck.vue?vue&type=script&lang=js"
import style0 from "./AdminTab_Duck.vue?vue&type=style&index=0&id=a4343c04&prod&lang=css"
import style1 from "./AdminTab_Duck.vue?vue&type=style&index=1&id=a4343c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4343c04",
  null
  
)

export default component.exports